import styled from 'styled-components'

export const FlowRequestModalText = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
`

export const FlowRequestModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  
  button {
    margin-left: 16px;
  }

`
